import React from 'react'
import CardItem from './CardItem'
import { Row } from 'react-bootstrap';
import './CardSelect.scss';

export interface CardItemProps {
    title: string;
    subTitle: string;
    id: string;
    selected: boolean;
}

interface CardSelectProps {
    items: CardItemProps[];
    onSelect: Function
}

const CardSelect = ({ items, onSelect }: CardSelectProps) => {

    const handleSelect = (id: any) => {
        onSelect(id);
    }

    function renderItem(item: CardItemProps, idx: number) {
        const { title, subTitle, id, selected } = item;
        return (<CardItem title={title} subTitle={subTitle} selected={selected} id={id} select={handleSelect} key={idx} g-2/>);
    }

    return (
        <Row className='g-3 ml-1 mr-1'>
            {items.map((item: CardItemProps, idx: number) => renderItem(item, idx))}
        </Row>
    );
}

export default CardSelect